import React from "react";

/**
 * Indicatore visivo della qualità del segnale GPS in base a `accuracy` (metri).
 * - null/undefined → "GPS in attesa…"
 * - ≤10m Ottimo · ≤20m Buono · ≤50m Medio · >50m Scarso
 */
export default function GPSQualityIndicator({ accuracy }) {
  if (accuracy === null || accuracy === undefined) {
    return (
      <div
        className="flex items-center gap-2 text-xs text-ink-500 font-bold"
        data-testid="gps-quality-waiting"
      >
        <span>○○○○○</span>
        <span>GPS in attesa…</span>
      </div>
    );
  }
  let quality, color, icon;
  if (accuracy <= 10) { quality = "Ottimo"; color = "text-forest"; icon = "●●●●●"; }
  else if (accuracy <= 20) { quality = "Buono"; color = "text-yellow-600"; icon = "●●●●○"; }
  else if (accuracy <= 50) { quality = "Medio"; color = "text-orange-500"; icon = "●●●○○"; }
  else { quality = "Scarso"; color = "text-compass"; icon = "●●○○○"; }
  return (
    <div
      className={`flex items-center gap-2 text-xs font-bold ${color}`}
      data-testid={`gps-quality-${quality.toLowerCase()}`}
    >
      <span>{icon}</span>
      <span>GPS ±{Math.round(accuracy)}m · {quality}</span>
    </div>
  );
}
